module.exports = __webpack_public_path__ + "img/cancel.22362627.svg";